import axios from "axios";
// import router from "@/router";

const normalApiBaseUrl = process.env.VUE_APP_MAIN_API_BASE_URL;
const normalSMSApiBaseUrl = process.env.VUE_APP_MAIN_SMS_API_BASE_URL;

const normalSMSRequest = axios.create({
  baseURL: normalSMSApiBaseUrl,
});

const getAuthorizationHeader = (token, additionalHeaders = {}) => {
  return {
    ...additionalHeaders,
    Authorization: "Bearer " + token,
  };
};

const createAxiosInstance = (headers) => {
  const instance = axios.create({
    baseURL: normalApiBaseUrl,
    headers,
    withCredentials: true,
  });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("_token");
      //   console.log("orignial_token", token);
      config.headers = getAuthorizationHeader(token, headers);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      //   console.log(response);
      const newAccessToken = response.headers["new_access_token"];
      //   console.log("new_access_token", newAccessToken);
      if (newAccessToken) {
        localStorage.setItem("_token", newAccessToken);
      }
      return response;
    },
    (error) => {
      if (error.response.data === "RefreshToken過期") {
        console.log("登入逾時，請重新登入");
        // router.push({
        //   path: "/signin",
        //   query: { status: "signIn", token: "expiry" },
        // });
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

const normalRequest = createAxiosInstance({});
const logoutRequest = createAxiosInstance({ Logout: "logout" });

// withCredentials: true  瀏覽器才會存取 set-cookies

export const Profile_Get = (email) => normalRequest.get(`Profile/${email}`);
export const Profile_Post = (data) => normalRequest.post(`Profile`, data);

export const Advertise_Get_ManageList = () => normalRequest.get(`Advertise/list/manage`);
export const Advertise_Post_UpdateImage = (id, data) => normalRequest.post(`Advertise/img/${id}`, data);
export const Advertise_Post_OnlineAds = (id) => normalRequest.post(`Advertise/online/${id}`);
export const Advertise_Delete = (id) => normalRequest.delete(`Advertise/${id}`);

export const Advertise_Post = (data) => normalRequest.post(`Advertise`, data);
export const Advertise_Get_Category = () => normalRequest.get(`Advertise/category`);
export const Advertise_Get_Area = () => normalRequest.get(`Advertise/area`);
export const Advertise_Get_Dist = () => normalRequest.get(`Advertise/dist`);
export const Advertise_Get_Questionnaire = () => normalRequest.get(`Advertise/questionnaire`);
export const Advertise_Get_TaroSerivce = () => normalRequest.get(`Advertise/taroSerivce`);
export const Advertise_SemdAdminMail = (data) => normalRequest.post(`Advertise/mail`, data);

export const GetCompanyData = (name, once) => normalRequest.get(`Advertise/company/${name}/${once}`);

export const Advertise_Search = (data) => normalRequest.post(`Advertise/search`, data);

export const Google_GetSiteToken = (letter) => normalRequest.get(`Google/siteToken/${letter}`);
export const Google_Login = () => normalRequest.get(`Google/googleLogin`);
export const Google_SignupWithRef = (refc) => normalRequest.get(`Google/googleLogin/${refc}`);

export const Token_LogOut = () => logoutRequest.get(`Token/logout`);
export const Token_Refresh = () => normalRequest.get(`Token/refresh`);

export const Token_SignIn = (data) => normalRequest.post(`Token/signin`, data);
export const Token_Username = () => normalRequest.get(`Token/username`);
export const Token_EmailEncrypt = () => normalRequest.get(`Token/emailEncrypt`);
export const Token_Email = () => normalRequest.get(`Token/email`);

export const Account_GetAccountSetting = (email) => normalRequest.get(`Account/info/${email}`);
export const Account_SignUp = (data) => normalRequest.post(`Account`, data);
export const Account_UpdatePwd = (data) => normalRequest.put(`Account`, data);

export const Mail_SendResetPwdMail = (email) => normalRequest.post(`Mail/SendResetPwdMail/${email}`);
export const Mail_SendConfirmMail = (data) => normalRequest.post(`Mail/SendConfirmMail`, data);

export const IndustryCategory_Get = () => axios.get("https://marketexploit.kf-9595.com/api/稅務行業標準分類");

export const GetCompanyData_Post = (data) => axios.post("https://marketexploit.kf-9595.com/api/Company", data);

export const GetIndustryVAT = (vat) => axios.get(`https://eip.fia.gov.tw/OAI/api/businessRegistration/${vat}`);

export default {};

export const SMS_GetCommunityList = () => normalSMSRequest.get(`Community/list/manage`);
export const Community_Mothball = (id) => normalSMSRequest.put(`Community/mothball/${id}`);
export const Community_Unmothball = (id) => normalSMSRequest.put(`Community/unmothball/${id}`);
export const Community_MothballCommunityAdminSendMails = (id) => normalSMSRequest.put(`Community/mothball/mail/admin/${id}`);

export const TokenPurchase_GetProductsByTypeId = (typeId) => normalRequest.get(`TokenPurchase/products/${typeId}`);
export const TokenPurchase_GetTypes = () => normalRequest.get(`TokenPurchase/types`);
export const TokenPurchase_CreateOrder = (dto) => normalRequest.post(`TokenPurchase/order/create`, dto);
export const TokenPurchase_UpdatePayment = (dto) => normalRequest.put(`TokenPurchase/order/payment`, dto);
export const TokenPurchase_GetOrderByNo = (orderNo) => normalRequest.get(`TokenPurchase/order/${orderNo}`);
export const TokenPurchase_GetUserTokenSummary = (email) => normalRequest.get(`TokenPurchase/users/sum/${email}`);
export const TokenPurchase_GetUserToken = (orderNo) => normalRequest.get(`TokenPurchase/users/token/${orderNo}`);

export const TokenPurchase_GetUserPurchasesRecord = (email, page, size, dateFilter, tokenTypeCode, feedFilter) => normalRequest.get(`TokenPurchase/${email}/purchases?p=${page}&ps=${size}&df=${dateFilter}&tt=${tokenTypeCode}&ff=${feedFilter}`);
export const TokenPurchase_GetUserPurchasesRecordSum = (email, tokenCode) => normalRequest.get(`TokenPurchase/${email}/purchases/summary?tt=${tokenCode}`);
export const TokenPurchase_GetTokenLogs = (
  email,
  page,
  size,
  usageLogKinds, // array
  service,
  date
) => {
  const ukParams = usageLogKinds.map((kind) => `uk=${encodeURIComponent(kind)}`).join("&");
  const url = `TokenPurchase/${email}/token-logs` + `?p=${page}&ps=${size}` + `&${ukParams}` + `&sv=${encodeURIComponent(service)}` + `&df=${encodeURIComponent(date)}`;
  return normalRequest.get(url);
};

export const NewebPay_Once = (dto) => normalRequest.post(`NewebPay/once`, dto);
